import "../styles/general.css";

import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate, useParams } from "react-router-dom";

import CarDetailsBox from "../components/cardetailsbox/CarDetailsBox";
import ChangeKmModal from "../components/changeKmModal/ChangeKmModal";
import DesktopView from "../components/desktopview/DesktopView";
import Footer from "../components/footer/Footer";
import Header from "../components/header/Header";
import BlueLoader from "../components/loader/BlueLoader";
import ConformationModal from "../components/modals/ConformationModal";
import MessageModals from "../components/modals/MessageModals";
import globalContext from "../Contexts/GlobalContext";
import Info from "../components/info/Info";

import {
  PIECES_TITLE,
  PIECES_TERMSMODE,
  PIECES_REPLACETEXT,
  PIECES_TITLETEXTMODE,
  PIECES_REQUESTTEXT,
} from "../constants/pieces";
import { SHOW_PIECES } from "../constants/piecesIcon";
import { PIECE_DETAILS_SIGMENTS } from "../constants/pieceDetailsSigments";
import ChangeKmsConf from "../components/modals/ChangeKmsConf";
import { SERVERMESSAGE } from "../constants/serverMessage";
import { SERVERMODE } from "../constants/serverMode";
import { handleServerMode } from "../utils/handleServer";
import useRequestHeader from "../hooks/useRequestHeader";
import { addCommas, p2e, removeNonNumeric } from "../utils/functions";

export default function PieceDetails() {
  const BASE_URL = process.env.REACT_APP_ROOT_API_ADDRESS;

  const navigate = useNavigate();
  const [cookies, setCookies, removeCookies] = useCookies([]);
  const requestHeader = useRequestHeader();
  const [bodyHeight, setBodyHeight] = useState(0);
  //// ref passes start  ////

  const [isLoadingData, setIsLoadingData] = useState(false);
  const [isLoadingPh, setIsLoadingPh] = useState(false);

  const contextData = useContext(globalContext);

  //// ref passes end ////
  const headerRef = useRef();
  const footerRef = useRef();

  const titleRef = useRef();
  const gajeRef = useRef();

  const bodyRef = useRef();

  //// INPUTS REF SECTION START ////
  const inp1Ref = useRef();
  const inp2Ref = useRef();
  //// INPUTS REF SECTION END ////

  //// ----->
  const [kmCu, setKmCu] = useState("");
  const [kmRequest, setKmRequest] = useState("");
  //// ----->

  const [itemHeight, setItemHeight] = useState(0);

  const spedometerRef = useRef();
  const [sigmentWidth, setSigmentWidth] = useState(0);
  const [sigmentHeight, setSigmentHeight] = useState(0);
  const [sigmentLeft, setSigmentLeft] = useState(0);

  //// single percent section  start ////
  const [percent, setPercent] = useState("00");
  const [pieceName, setPieceName] = useState("");
  const [singlePieceImg, setSinglePieceImg] = useState("");
  const [singlePieceType, setSinglePieceType] = useState("");
  //// single percent section  end ////

  const [kmTavizPlace, setKmTavizPlace] = useState("");
  const [kmReplacePlace, setKmReplacePlace] = useState("");
  // ----->
  const [checkInputsIsValid, setCheckInputsIsValid] = useState(false);
  // ----->

  const [IsKmUpdateConfOpen, setIsKmUpdateConfOpen] = useState(false);
  const [kmUpdateConfMessage, setkmUpdateConfMessage] = useState("");
  const [kmUpdateConfTitle, setKmUpdateConfTitle] = useState("");
  useEffect(() => {
    setBodyHeight(
      window.innerHeight -
        headerRef?.current?.offsetHeight -
        footerRef?.current?.offsetHeight
    );
    setItemHeight(
      window.innerHeight -
        headerRef?.current?.offsetHeight -
        footerRef?.current?.offsetHeight -
        gajeRef?.current?.offsetHeight -
        titleRef?.current?.offsetHeight -
        (parseInt(titleRef.current.style["marginTop"]) * window.innerWidth) /
          100 -
        (parseInt(titleRef.current.style["marginTop"]) * window.innerWidth) /
          100
    );

    setSigmentWidth(spedometerRef?.current?.clientWidth / 4.472008276813427);
    setSigmentHeight(spedometerRef?.current?.clientHeight / 2.456800099453008);
    setSigmentLeft(
      (window?.innerWidth - spedometerRef?.current?.clientWidth) / 2 +
        spedometerRef?.current?.clientWidth / 11.85539358600583
    );
  }, []);

  //// params section start ////
  const params = useParams();
  //// params section end ////

  //// useeffect section start ////
  useEffect(() => {
    let data = params.data;
    let dataArr = data.split("_");
    setPercent(dataArr[0]);
    setPieceName(dataArr[1]);
  }, []);
  //// useeffect section end ////

  //// updateSinglePiece function start ////
  const updateSinglePiece = (ok, setIsLoadingDataConf) => {
    setCheckInputsIsValid(true);
    if (
      Number(kmRequest.replace(",", "").replaceAll("km", "")) >= 50 &&
      Number(kmCu.replaceAll(",", "").replaceAll("km", "")) > 0
    ) {
      setIsLoadingData(true);
      let kmCut;
      kmCut = kmCu.replaceAll(",", "").replaceAll("km", "");

      let kmreq;
      kmreq = kmRequest.replaceAll(",", "").replaceAll("km", "");

      const config = {
        headers: requestHeader,
      };
      let requestBody = {
        pieceName: pieceName,
        kmReplace: kmCut,
        kmRequest: kmreq,
        mode: "Edit",
        carID: cookies?.carID,
      };
      if (ok === "true") {
        requestBody.isValid = "true";
      }
      axios
        .post(`${BASE_URL}/service/updateKmPiece`, requestBody, config)
        .then((res) => {
          setIsLoadingData(false);
          if (setIsLoadingDataConf) {
            setIsLoadingDataConf(false);
          }
          var responseMode = res?.data?.Mode;
          var responseMessage = res?.data?.Message;
          switch (responseMode) {
            case SERVERMODE.REQUEST_OK: {
              if (Number(kmCut) >= Number(cookies?.kmCurrent)) {
                setCookies("kmCurrent", kmCut, { path: "/" });
              }

              navigate("/short-terms");
              contextData.setIsToastOpen(true);
              contextData.setToastMessage(SERVERMESSAGE.successUpdateKmPiece);
              break;
            }
            case SERVERMODE.DATA_ILLOGICAL: {
              setIsKmUpdateConfOpen(true);
              setkmUpdateConfMessage(res?.data?.Message);
              break;
            }
            case SERVERMODE.WRONG_KM_REPLACE: {
              contextData.setIsToastOpen(true);
              contextData.setToastMessage(SERVERMESSAGE.wrongUpdateKmPiece);
              break;
            }
            default: {
              handleServerMode(
                responseMode,
                responseMessage,
                contextData,
                cookies,
                removeCookies,
                navigate
              );
            }
          }
        })
        .catch((err) => {
          setIsLoadingData(false);
          if (setIsLoadingDataConf) {
            setIsLoadingDataConf(false);
          }
          contextData.setIsToastOpen(true);
          contextData.setToastMessage("ارتباط با سرور دچار مشکل شده است");
        });
    }
  };
  //// updateSinglePiece function end ////

  window.addEventListener("resize", () => {
    setBodyHeight(
      window?.innerHeight -
        headerRef?.current?.offsetHeight -
        footerRef?.current?.offsetHeight
    );
    setItemHeight(
      window?.innerHeight -
        headerRef?.current?.offsetHeight -
        footerRef?.current?.offsetHeight -
        gajeRef?.current?.offsetHeight -
        titleRef?.current?.offsetHeight -
        (parseInt(titleRef?.current?.style["marginTop"]) * window.innerWidth) /
          100 -
        (parseInt(titleRef?.current?.style["marginTop"]) * window.innerWidth) /
          100
    );

    setSigmentWidth(spedometerRef?.current?.clientWidth / 4.472008276813427);
    setSigmentHeight(spedometerRef?.current?.clientHeight / 2.456800099453008);
    setSigmentLeft(
      (window?.innerWidth - spedometerRef?.current?.clientWidth) / 2 +
        spedometerRef?.current?.clientWidth / 11.85539358600583
    );
  });

  useEffect(() => {
    if (pieceName) {
      setIsLoadingPh(true);
      const config = {
        headers: requestHeader,
      };
      axios
        .post(
          `${BASE_URL}/service/lastKmReplace`,
          {
            carID: cookies?.carID,
            pieceName: pieceName,
          },
          config
        )
        .then((res) => {
          var responseMode = res?.data?.Mode;
          var responseMessage = res?.data?.Message;
          switch (responseMode) {
            case SERVERMODE.REQUEST_OK: {
              setKmTavizPlace(res?.data?.Data?.kmReplace + "km");
              setKmReplacePlace(res?.data?.Data?.kmRequest + "km");
              break;
            }
            default: {
              handleServerMode(
                responseMode,
                responseMessage,
                contextData,
                cookies,
                removeCookies,
                navigate
              );
            }
          }
          setIsLoadingPh(false);
        })
        .catch(() => {
          setIsLoadingPh(false);
        });
    }
  }, [pieceName]);

  return (
    <>
      <div className="hidden min-[1024px]:block">
        <DesktopView />
      </div>
      <div className="w-full  overflow-hidden min-[1024px]:hidden">
        {contextData?.isInfoOpen && (
          <Info
            infoText={
              "کاربر عزیز مشخصات خودرو شما در این صفحه نمایش داده شده و کد اختصاصی خودرو شما در سامانه اسکارپین در قسمت بالا درج شده است. شما می‌توانید تمامی پارامترهای موجود را در صورت نیاز ویرایش نمایید. \n در زمان مراجعه به اتوسرویس جهت سهولت در فرآیند سرویس خودرو شما می\u200cتوانید بارکد اسکارپین را که در قسمت بالا درج شده است توسط تعمیرکار اسکن شده و اتوسرویس موقتا اطلاعات خودرو شما را مشاهده و ارزیابی می\u200cگردد."
            }
          />
        )}

        <img
          src="../assets/images/body/body-bgimg.png"
          alt=""
          className="absolute w-full h-full top-0  right-0 -z-50"
        />
        {contextData.isToastOpen && (
          <MessageModals
            setIsOpen={contextData.setIsToastOpen}
            message={contextData.toastMessage}
          />
        )}

        <Header forwardRef={headerRef} />
        {contextData?.changeKmModalIsOpen && <ChangeKmModal />}
        {IsKmUpdateConfOpen && (
          <ChangeKmsConf
            setIsKmUpdateConfOpen={setIsKmUpdateConfOpen}
            sendAllData={updateSinglePiece}
            message={kmUpdateConfMessage}
          />
        )}
        <div
          ref={bodyRef}
          style={{ height: `${bodyHeight + 9}px` }}
          className="w-full  -mt-[9px] flex flex-col justify-start  "
        >
          <CarDetailsBox forwardRef={titleRef} mt={"3.883"} mb={"3.883"} />
          <div className="w-full h-[180vh] overflow-auto  ">
            <div
              ref={gajeRef}
              className="relative w-[91.75vw] mx-auto flex items-center justify-center h-[93.21933962264151vw]"
            >
              {Math.round(percent / 5) * 5 !== 0 && (
                <div className="absolute  w-[92.45283018867925vw] h-[92.45283018867925vw] z-50 top-0 left-0">
                  {PIECE_DETAILS_SIGMENTS(Math.round(percent / 5) * 5)}
                </div>
              )}

              <img
                ref={spedometerRef}
                src="../assets/images/sigments/speedometer.png"
                alt=""
                className="absolute top-0 mx-auto w-[92.45283018867925vw] h-[93.60377358490566vw]"
              />
              <div className="absolute flex flex-col items-center justify-center">
                <div className="flex items-center justify-center">
                  <span className="text-[5vw] text-color-primary-D font-font_primary_D self-end">
                    %
                  </span>
                  <span className="text-[18vw] leading-[12vw] text-color-primary-D font-font_primary_D">
                    {percent < 10 ? `0${percent}` : `${percent}`}
                  </span>
                </div>
                <span className="text-center text-[4vw] text-color-primary-D font-font_primary_D ">
                  Remaining
                </span>
              </div>
              <div className="absolute top-[75.75757575757576%] right-[30.25641025641026%]">
                <div className="w-[10vw] h-[10vw]">
                  {SHOW_PIECES(pieceName, "#00FFF2", "10vw", "10vw")}
                </div>
              </div>
              <div className="absolute bottom-0">
                <span className=" text-color-primary-D font-font_primary_A text-[5vw] leading-[14vw]">
                  {PIECES_TITLE[pieceName]}
                </span>
              </div>
            </div>

            <div
              style={{
                height: `${
                  inp1Ref?.current?.clientHeight +
                    inp2Ref?.current?.clientHeight <
                  itemHeight
                    ? `${itemHeight}px`
                    : `${
                        inp1Ref?.current?.clientHeight +
                        inp2Ref?.current?.clientHeight +
                        50
                      }px`
                }    `,
              }}
              className="w-full flex flex-col items-center justify-evenly"
            >
              <div
                ref={inp1Ref}
                className="relative w-[78.09905660377358vw] h-[14.15094339622642vw] flex items-center justify-center  "
              >
                <span className="absolute top-[5vw] right-[2vw] text-color-primary-D text-[3vw] font-font_primary_A z-10">
                  {PIECES_REPLACETEXT[PIECES_TITLETEXTMODE[pieceName]]}
                </span>
                <div className="absolute top-0 w-[78.09905660377358vw] h-[14.15094339622642vw]">
                  <svg
                    width="78.09905660377358vw"
                    height="14.15094339622642vw"
                    viewBox="0 0 330 60"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M8.11546 0.125122H321.885C326.266 0.125122 329.854 3.71344 329.854 8.09452V51.9054C329.854 56.2865 326.266 59.8748 321.885 59.8748H8.11546C3.73437 59.8748 0.146057 56.2865 0.146057 51.9054V8.09452C0.146057 3.71344 3.73437 0.125122 8.11546 0.125122Z"
                      fill="#001D26"
                      fillOpacity="0.701961"
                      stroke="#00FFF2"
                      strokeOpacity="0.701961"
                      strokeWidth="0.292072"
                      strokeMiterlimit="2.61313"
                    />
                  </svg>
                  {isLoadingPh && (
                    <div className="absolute top-0 left-0  w-[100%]  h-[100%] backdrop-blur-[1px] flex items-center justify-center rounded-[1.5vw] z-[1000]">
                      <BlueLoader position="relative" width={10} />
                    </div>
                  )}
                </div>

                <input
                  type="text"
                  dir="ltr"
                  maxLength={7}
                  value={kmCu}
                  autoComplete="off"
                  placeholder={addCommas(removeNonNumeric(p2e(kmTavizPlace)))}
                  className={`w-[78.09905660377358vw]  h-[14.15094339622642vw] leading-[9.5vw] bg-transparent pl-[2vw] rounded-[1.886792452830189vw] z-[50] text-[9vw] focus:text-[9vw] font-font_primary_D focus:font-font_primary_D text-color-primary-D focus:text-color-primary-D outline-none ttxx placeholder:font-font_primary_D ${
                    checkInputsIsValid
                      ? Number(kmCu.replaceAll(",", "").replaceAll("km", "")) <
                        1
                        ? "border-[1px] border-[#ED3237]"
                        : ""
                      : ""
                  }`}
                  onChange={(e) => {
                    setKmCu(addCommas(removeNonNumeric(p2e(e.target.value))));
                  }}
                  onBlur={() => {
                    if (kmCu.replaceAll(",", "") !== "")
                      setKmCu((prev) => prev + "km");
                  }}
                  onFocus={() => {
                    if (kmCu.includes("km"))
                      setKmCu((prev) => prev.slice(0, prev.length - 2));
                  }}
                />
              </div>

              {/* /// row two start /// */}
              <div
                ref={inp2Ref}
                className="relative w-[78.09905660377358vw] h-[15vw] flex items-center justify-between"
              >
                <span className="absolute top-[5vw] right-[21vw] text-color-primary-D text-[3vw] font-font_primary_A z-10">
                  {PIECES_REQUESTTEXT[PIECES_TITLETEXTMODE[pieceName]]}
                </span>
                <div className="absolute top-0 bottom-0 left-0 w-[60.88vw] h-[14.15094339622642vw]">
                  {checkInputsIsValid ? (
                    Number(kmRequest.replace(",", "").replaceAll("km", "")) <
                    50 ? (
                      <svg
                        width="60.88vw"
                        height="14.15094339622642vw"
                        viewBox="0 0 256 62"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M8.6497 0.811035H246.71C251.123 0.811035 254.689 4.42154 254.689 8.78954V52.604C254.689 57.0161 251.123 60.5826 246.71 60.5826H8.6497C4.2817 60.5826 0.671143 57.0161 0.671143 52.604V8.78954C0.671143 4.42154 4.2817 0.811035 8.6497 0.811035Z"
                          fill="#001D26"
                          fillOpacity="0.701961"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M8.6497 0.811035H246.71C251.123 0.811035 254.689 4.42154 254.689 8.78954V52.604C254.689 57.0161 251.123 60.5826 246.71 60.5826H8.6497C4.2817 60.5826 0.671143 57.0161 0.671143 52.604V8.78954C0.671143 4.42154 4.2817 0.811035 8.6497 0.811035Z"
                          stroke="#ED3237"
                          strokeWidth="0.98016"
                          strokeMiterlimit="2.61313"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M8.6497 0.811035H246.71C251.123 0.811035 254.689 4.42154 254.689 8.78954V52.604C254.689 57.0161 251.123 60.5826 246.71 60.5826H8.6497C4.2817 60.5826 0.671143 57.0161 0.671143 52.604V8.78954C0.671143 4.42154 4.2817 0.811035 8.6497 0.811035Z"
                          stroke="#ED3237"
                          strokeWidth="0.26784"
                          strokeMiterlimit="2.61313"
                        />
                      </svg>
                    ) : (
                      <svg
                        width="60.88vw"
                        height="14.15094339622642vw"
                        viewBox="0 0 256 61"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.02694 0.525391H246.886C251.279 0.525391 254.863 4.10915 254.863 8.50211V52.2781C254.863 56.6711 251.279 60.2355 246.886 60.2355H9.02694C4.63398 60.2355 1.05029 56.6711 1.05029 52.2781V8.50211C1.05029 4.10915 4.63398 0.525391 9.02694 0.525391Z"
                          fill="#001D26"
                          fillOpacity="0.701961"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.02694 0.525391H246.886C251.279 0.525391 254.863 4.10915 254.863 8.50211V52.2781C254.863 56.6711 251.279 60.2355 246.886 60.2355H9.02694C4.63398 60.2355 1.05029 56.6711 1.05029 52.2781V8.50211C1.05029 4.10915 4.63398 0.525391 9.02694 0.525391Z"
                          stroke="#00FFF2"
                          strokeWidth="0.28896"
                          strokeMiterlimit="2.61313"
                        />
                      </svg>
                    )
                  ) : (
                    <>
                      <svg
                        width="62.2vw"
                        height="14.15094339622642vw"
                        viewBox="0 0 256 61"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.02694 0.525391H246.886C251.279 0.525391 254.863 4.10915 254.863 8.50211V52.2781C254.863 56.6711 251.279 60.2355 246.886 60.2355H9.02694C4.63398 60.2355 1.05029 56.6711 1.05029 52.2781V8.50211C1.05029 4.10915 4.63398 0.525391 9.02694 0.525391Z"
                          fill="#001D26"
                          fillOpacity="0.701961"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.02694 0.525391H246.886C251.279 0.525391 254.863 4.10915 254.863 8.50211V52.2781C254.863 56.6711 251.279 60.2355 246.886 60.2355H9.02694C4.63398 60.2355 1.05029 56.6711 1.05029 52.2781V8.50211C1.05029 4.10915 4.63398 0.525391 9.02694 0.525391Z"
                          stroke="#00FFF2"
                          strokeWidth="0.28896"
                          strokeMiterlimit="2.61313"
                        />
                      </svg>
                      {isLoadingPh && (
                        <div className="absolute top-0 left-0  w-[100%]  h-[100%] backdrop-blur-[1px] flex items-center justify-center rounded-[1.5vw] z-[1000]">
                          <BlueLoader position="relative" width={10} />
                        </div>
                      )}
                    </>
                  )}
                </div>

                {isLoadingData ? (
                  <>
                    <div className="w-[14.15094339622642vw] h-[14.15094339622642vw] bg-[#00FFF2] rounded-[1.886792452830189vw] flex items-center justify-center">
                      <BlueLoader position="" width={8} />
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className="w-[14.15094339622642vw] h-[14.15094339622642vw]"
                      onClick={updateSinglePiece}
                    >
                      {Number(
                        kmRequest.replaceAll(",", "").replaceAll("km", "")
                      ) >= 50 &&
                      Number(kmCu.replaceAll(",", "").replaceAll("km", "")) >
                        0 ? (
                        <svg
                          width="14.15094339622642vw"
                          height="14.15094339622642vw"
                          viewBox="0 0 60 60"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_59_12)">
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M8.01843 0H51.9816C56.4055 0 60 3.59447 60 8.01843V51.9816C60 56.4055 56.4055 60 51.9816 60H8.01843C3.59447 60 0 56.4055 0 51.9816V8.01843C0 3.59447 3.59447 0 8.01843 0ZM47.2811 25.7143C47.2811 25.1613 47.0046 24.6083 46.7281 24.3318C46.4516 23.7788 45.6221 23.7788 45.3456 23.7788C44.5161 23.7788 43.9631 24.0553 43.6866 24.3318C43.4101 24.8848 43.1336 25.4378 43.1336 25.7143H40.9217C40.9217 25.1613 40.6452 24.6083 40.3687 24.3318C39.8157 23.7788 39.2627 23.7788 38.7097 23.7788C38.1567 23.7788 37.6037 24.0553 37.3272 24.3318C36.7742 24.8848 36.7742 25.4378 36.7742 25.7143H34.5622C34.5622 25.1613 34.2857 24.6083 34.0092 24.3318C33.4562 23.7788 32.9032 23.7788 32.3502 23.7788C31.7972 23.7788 31.5207 23.7788 30.9677 24.3318C30.6912 24.6083 30.4147 25.4378 30.4147 25.7143H28.2028V14.6544C28.2028 14.1014 27.6498 13.5484 27.3733 13.2719C26.8203 12.9954 26.2673 12.7189 25.9908 12.7189C25.4378 12.7189 24.8848 12.9954 24.6083 13.2719C24.0553 13.8249 24.0553 14.3779 24.0553 14.6544V32.3502C24.0553 32.6267 23.7788 33.1797 23.5023 33.4562C23.5023 33.7327 23.2258 34.0092 22.9493 34.0092C22.3963 34.2857 22.1198 34.2857 21.8433 34.0092C21.5668 34.0092 21.0138 34.0092 20.7373 33.7327L16.0369 29.0323C15.7604 28.4793 15.2074 28.4793 14.9309 28.4793C14.1014 28.4793 13.5484 28.7558 13.2719 29.0323C12.7189 29.3088 12.7189 29.8617 12.7189 30.4147C12.7189 30.9677 12.9954 31.5207 13.2719 31.7972L22.9493 41.7511C23.2258 42.0276 23.5023 42.3041 23.7788 42.8571C23.7788 43.1336 24.0553 43.4101 24.0553 43.9631V47.0046V47.2811C24.0553 47.5576 24.0553 47.5576 24.3318 47.5576C24.3318 47.8341 24.3318 47.8341 24.6083 47.8341C24.6083 47.8341 24.6083 47.8341 24.8848 47.8341H41.7511C43.4101 47.8341 44.7926 47.2811 45.6221 46.4516C46.7281 45.3456 47.2811 43.9631 47.2811 42.3041V25.7143ZM48.3871 22.9493C48.9401 23.5023 49.4931 24.6083 49.4931 25.7143V42.3041C49.4931 44.5161 48.6636 46.4516 47.2811 47.8341C45.8986 49.2166 43.9631 50.0461 41.7511 50.0461H24.8848C24.3318 50.0461 24.0553 50.0461 23.5023 49.7696C23.2258 49.7696 22.9493 49.4931 22.6728 49.2166C22.3963 48.9401 22.1198 48.6636 21.8433 48.1106C21.8433 47.8341 21.5668 47.2811 21.5668 47.0046V43.9631C21.5668 43.6866 21.5668 43.4101 21.2903 43.4101L11.6129 33.4562C11.0599 32.9032 10.5069 31.5207 10.5069 30.4147C10.5069 29.3088 10.7834 28.2028 11.6129 27.3733C12.1659 26.8203 13.5484 26.2673 14.9309 26.2673C15.7604 26.2673 16.8664 26.5438 17.6959 27.3733L21.5668 31.2442V14.6544C21.5668 13.8249 22.1198 12.7189 23.2258 11.6129C23.7788 11.0599 24.8848 10.5069 25.9908 10.5069C26.8203 10.5069 27.9263 10.7834 28.7558 11.6129C29.5853 12.1659 30.4147 13.2719 30.4147 14.6544V22.1198C30.9677 21.5668 31.5207 21.2903 32.3502 21.2903C33.1797 21.2903 34.5622 21.8433 35.6682 22.9493C36.2212 22.1198 37.3272 21.2903 38.7097 21.2903C39.5392 21.2903 40.9217 21.8433 42.0276 22.9493C42.8571 22.1198 43.9631 21.2903 45.3456 21.2903C46.1751 21.2903 47.2811 21.8433 48.3871 22.9493Z"
                              fill="#00FFF2"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_59_12">
                              <rect width="60" height="60" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      ) : (
                        <svg
                          width="14.15094339622642vw"
                          height="14.15094339622642vw"
                          viewBox="0 0 60 60"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_60_16)">
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M8 0H52C56.2667 0 59.7333 3.73333 59.7333 8V52C59.7333 56.2667 56.2667 59.7333 52 59.7333H8C3.73333 59.7333 0 56.2667 0 52V8C0 3.73333 3.73333 0 8 0Z"
                              fill="#001D26"
                              fillOpacity="0.701961"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M8 0H52C56.2667 0 59.7333 3.73333 59.7333 8V52C59.7333 56.2667 56.2667 59.7333 52 59.7333H8C3.73333 59.7333 0 56.2667 0 52V8C0 3.73333 3.73333 0 8 0Z"
                              stroke="#00FFF2"
                              strokeWidth="1"
                              strokeMiterlimit="2.61313"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M48.5333 42.1333V25.6C48.5333 23.4667 46.1333 22.4 45.3333 22.4C42.9333 22.4 42.1333 24.8 42.1333 25.6C42.1333 23.4667 39.7333 22.4 38.9333 22.4C36.5333 22.4 35.4667 24.8 35.4667 25.6C35.4667 23.4667 33.3333 22.4 32.2667 22.4C30.1333 22.4 29.0667 24.8 29.0667 25.6V14.6667C29.0667 12.5333 26.9333 11.4667 25.8667 11.4667C23.7333 11.4667 22.6667 13.8667 22.6667 14.6667V32.2667C22.6667 32.5333 22.6667 32.8 22.4 32.8C22.1333 33.0667 21.8667 33.0667 21.6 32.8L17.0667 28C15.4667 26.6667 13.3333 27.2 12.5333 28C10.9333 29.6 11.7333 31.7333 12.5333 32.5333L22.1333 42.4C22.4 42.6667 22.6667 43.2 22.6667 43.7333V46.6667C22.6667 47.2 22.9333 47.7333 23.4667 48.2667C23.7333 48.5333 24.2667 48.8 24.8 48.8H41.6C45.3333 48.8 48.2666 45.8667 48.2666 42.1333H48.5333Z"
                              stroke="#00FFF2"
                              strokeWidth="0.8"
                              strokeMiterlimit="2.61313"
                              strokeLinejoin="bevel"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_60_16">
                              <rect width="60" height="60" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      )}
                    </div>
                  </>
                )}

                <input
                  type="text"
                  dir="ltr"
                  maxLength={7}
                  autoComplete="off"
                  value={kmRequest}
                  placeholder={addCommas(removeNonNumeric(p2e(kmReplacePlace)))}
                  className={`w-[60.88vw] h-[14.15094339622642vw]  pl-[2vw]  border-color-primary-D bg-transparent rounded-[1.886792452830189vw] z-[50] text-[8.8vw] focus:text-[8.8vw] font-font_primary_D focus:font-font_primary_D text-color-primary-D focus:text-color-primary-D outline-none placeholder:font-font_primary_D  ttxx  `}
                  onChange={(e) => {
                    setKmRequest(
                      addCommas(removeNonNumeric(p2e(e.target.value)))
                    );
                  }}
                  onBlur={() => {
                    if (kmRequest.replaceAll(",", "") !== "")
                      setKmRequest((prev) => prev + "km");
                  }}
                  onFocus={() => {
                    if (kmRequest.includes("km"))
                      setKmRequest((prev) => prev.slice(0, prev.length - 2));
                  }}
                />
              </div>
            </div>
          </div>
          <Footer forwardRef={footerRef} />
        </div>
      </div>
    </>
  );
}
